import React from "react";
import SelectDropdown from "../FieldsComponents/SelectDropdown/SelectDropdown";
import DateDropdown from "../FieldsComponents/DateDropdown/DateDropdown";
import TextInputField from "../FieldsComponents/TextInputField/TextInputField";
import SubGridVanilla from "../SubGrid/SubGridVanilla";
import SubGridVanillaMobile from "../SubGrid/SubGridVanillaMobile";
import PhotoUpload from "../FieldsComponents/PhotoUpload/PhotoUpload";

const getMandatoryAstric = fieldDef => {
  if (fieldDef && fieldDef.isMust && fieldDef.isMust === "true") {
    //console.log(fieldDef.caption + "=" + fieldDef.isMust);
    return "*";
  } else {
    //console.log(fieldDef.caption + "=" + fieldDef.isMust);
    return "";
  }
};

const getInputField = (
  fieldName,
  tableName,
  stateRcvd,
  statehandler,
  disabled,
  tableOgDef,
  db,
  isMobile
) => {
  if (!tableOgDef || !tableOgDef[tableName]) {
    console.log(
      tableName +
        " | " +
        fieldName +
        " | " +
        JSON.stringify(tableOgDef.projectPos)
    );
    console.log("~~~~~~~~");
    return <div></div>;
  }

  const fieldDef = tableOgDef[tableName][fieldName];
  if (fieldDef && fieldDef.isHidden === "true") {
    return <div></div>;
  }
  //console.log("~~~ " + fieldDef.caption + ">> " + getMandatoryAstric(fieldDef));
  if (fieldDef) {
    if (fieldDef.type === "input" || fieldDef.type === "calculation") {
      return (
        <TextInputField
          title={fieldDef.caption + getMandatoryAstric(fieldDef)}
          value={
            stateRcvd.payload && stateRcvd.payload !== undefined
              ? stateRcvd.payload[fieldName]
              : null
          }
          stateChangeHandler={statehandler}
          fieldName={fieldName}
          disabled={fieldDef.enabled === "false"}
          type={fieldDef.isSecure === "true" ? "password" : null}
          message={stateRcvd.validationError}
          placeholder={fieldDef.placeholder}
        />
      );
    } else if (fieldDef.type === "photoUpload") {
      return (
        <PhotoUpload
          title={fieldDef.caption + getMandatoryAstric(fieldDef)}
          images={
            stateRcvd.payload && stateRcvd.payload !== undefined
              ? stateRcvd.payload[fieldName]
              : []
          }
          fieldName={fieldName}
          isPayload={true}
          stateChangeHandler={statehandler}
          disabled={fieldDef.enabled === "false"}
        />
      );
    } else if (fieldDef.type === "textarea") {
      return (
        <TextInputField
          title={fieldDef.caption + getMandatoryAstric(fieldDef)}
          value={
            stateRcvd.payload && stateRcvd.payload !== undefined
              ? stateRcvd.payload[fieldName]
              : null
          }
          stateChangeHandler={statehandler}
          fieldName={fieldName}
          multiline
          multilineRows={{ min: parseInt(fieldDef.numOfLines) }}
          resize="manual"
          disabled={fieldDef.enabled === "false"}
          placeholder={fieldDef.placeholder}
        />
      );
    } else if (fieldDef.type === "search") {
      if (fieldDef.selectorSource.type === "static") {
        let sourceFieldName = fieldDef.selectorSource.tableField;
        return (
          <SelectDropdown
            title={fieldDef.caption + getMandatoryAstric(fieldDef)}
            data={fieldDef.selectorSource.staticSource}
            label={fieldDef.caption}
            placeholder={fieldDef.placeholder}
            value={
              stateRcvd.payload && stateRcvd.payload !== undefined
                ? stateRcvd.payload[fieldName]
                : null
            }
            stateFieldName={fieldName}
            isPayload={true}
            fieldName={sourceFieldName}
            stateHandler={statehandler}
            disabled={fieldDef.enabled === "false" ? true : false}
          />
        );
      } else {
        let sourceTableName = fieldDef.selectorSource.table;
        let sourceFieldName = fieldDef.selectorSource.tableField;
        return (
          <SelectDropdown
            title={fieldDef.caption + getMandatoryAstric(fieldDef)}
            data={db[sourceTableName]}
            label={fieldDef.caption}
            placeholder={fieldDef.caption}
            value={
              stateRcvd.payload && stateRcvd.payload !== undefined
                ? stateRcvd.payload[fieldName]
                : null
            }
            stateFieldName={fieldName}
            isPayload={true}
            fieldName={sourceFieldName}
            stateHandler={statehandler}
            disabled={fieldDef.enabled === "false" ? true : false}
            otherFields={fieldDef.otherFieldsToUpdate}
            filter={fieldDef.filters}
            stateRcvd={stateRcvd}
          />
        );
      }
    } else if (fieldDef.type === "accountingRule") {
      return (
        <AccRuleGridVanilla
          title={fieldDef.caption + getMandatoryAstric(fieldDef)}
          data={
            stateRcvd.payload && stateRcvd.payload !== undefined
              ? stateRcvd.payload[fieldName]
              : []
          }
          stateChangeHandler={statehandler}
          stateFieldName={fieldName}
          isPayload={true}
          emptyRow={{
            accSide: "",
            targetTable: "",
            amountField: "",
            matchField: "",
            referencField: "",
            acctDateField: ""
          }}
          emptyTitle={"Add Accounting Rule"}
          tableOgDef={tableOgDef}
        />
      );
    } else if (fieldDef.type === "calendar") {
      return (
        <DateDropdown
          title={fieldDef.caption + getMandatoryAstric(fieldDef)}
          //maxDetail={fieldDef.dateMaxDetail === "minute" ? "minute" : ""}
          format={fieldDef.dateFormat}
          formatOut={fieldDef.dateFormatOut}
          onChange={statehandler}
          fieldName={fieldName}
          value={
            stateRcvd.payload && stateRcvd.payload !== undefined
              ? stateRcvd.payload[fieldName]
              : null
          }
          disabled={fieldDef.enabled === "false"}
        />
      );
    } else if (fieldDef.type === "array") {
      // if (fieldName === "requestedItems") {
      //   console.log("generating field: " + fieldName);
      // }
      if (isMobile) {
        if (fieldName === "requestedItems") {
          console.log("it is mobile generating field: " + fieldName);
        }
        return (
          <div
            style={{
              textAlign: "center"
            }}
          >
            <SubGridVanillaMobile
              data={
                stateRcvd.payload && stateRcvd.payload !== undefined
                  ? stateRcvd.payload[fieldName]
                  : []
              }
              stateChangeHandler={statehandler}
              fieldName={fieldName}
              isPayload={true}
              colDefs={fieldDef.colDefs}
              emptyRow={fieldDef.emptyRow}
              caption={fieldDef.caption}
            />
          </div>
        );
      } else {
        return (
          <div
            style={{
              textAlign: "center",
              padding: "5px"
            }}
          >
            <SubGridVanilla
              data={
                stateRcvd.payload && stateRcvd.payload !== undefined
                  ? stateRcvd.payload[fieldName]
                  : []
              }
              stateChangeHandler={statehandler}
              fieldName={fieldName}
              isPayload={true}
              colDefs={fieldDef.colDefs}
              emptyRow={fieldDef.emptyRow}
              caption={fieldDef.caption}
            />
          </div>
        );
      }
      // return (
      //   <div
      //     style={{
      //       textAlign: "center",
      //       padding: "5px"
      //     }}
      //   >
      //     <SubGrid
      //       data={
      //         stateRcvd.payload && stateRcvd.payload !== undefined
      //           ? stateRcvd.payload[fieldName]
      //           : []
      //       }
      //       stateChangeHandler={statehandler}
      //       fieldName={fieldName}
      //       isPayload={true}
      //       colDefs={fieldDef.colDefs}
      //       emptyRow={fieldDef.emptyRow}
      //     />
      //   </div>
      // );
    }
  }
};

export default getInputField;



// WEBPACK FOOTER //
// ./src/app/components/Screens/customFields/getInputField.jsx